import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { Typography, 
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { writeGifFile } from '../util/videoUtil';
import { INFO } from '../util/object'
import { BUCKET_API_SERVER, NODE_API_SERVER } from '../util/constants'
import { getURL, 
         getVimeoURL,
         ReadDrillData } from '../util/database'
import { processGifVideo, 
         find_mp4_url,
         getSource,
        } from "../util/util";
//import Webcam from './Webcam';


const auth_useStyles = makeStyles(theme => ({
	    gif_root: {
			display: 'flex',
			flexDirection: 'column',
            margin: '0',
            padding: '0',
            width: '100%',
            height: '100%',
			backgroundColor:'#444444',	//4488ff
	    },
	    video_container: {
			//display: "none",
			padding: '0',
			margin: '0',
			width: "auto",
			height: "auto",
			flexDirection: "row",
			alignItems: "flex-start",

			marginLeft: '0',
			marginRight: '0',
			marginBottom: '0.7vh',
			width: '100%',
			height: '100%',
			paddingLeft: '0',
			paddingRight: '0',
			position: 'relative',
            fontSize: '10rem',
            color: 'red',
            background: "green",
			//overflow: 'hidden', 
	    },
	    img_container: {
			//display: "none",
			padding: '0',
			width: '200px',
			height: '140px',
        }
	}));


// UTIL: Create animated gif icons for drills
//
// ref: https://github.com/yahoo/gifshot
const Gif = (props) => {
    const classes = auth_useStyles();
    const [ Start, setStart ] = useState(false);

    useEffect(() => {
        var timer = setTimeout (() => {setStart(true)}, 1000);
    }, [1]); 

    useEffect(() => {
        if (Start === true) {
            processVideoStream();
        }
    }, [Start]); 

        async function processVideoStream() {
            var video_hash = INFO.gif_video_hash;
            var drill_key = INFO.gif_drill_key;
            var path = null, bits = null;

            console.log("gif.84:   dirll_key=",drill_key, " video_hash=",video_hash);
            if (drill_key) {
                // first get the video_id if called with "?d=<drill_key>"
                //
                var drills = await ReadDrillData("single", drill_key)
                console.log("asset.79:  drills=",drills);

                if (drills.length > 0) {
                    video_hash = drills[0].drill_video;
                    //bits = video_hash.split(":");
                } else {
                    console.log("asset.396:  BAD drill_key="+drill_key);
                    return null;
                }
            }

            bits = video_hash.split(":");
            var mode = bits[0];
            var video_id = bits[1];
            switch (mode) {
                case "y":
                    // feed the youtube proxy url to gif maker
                    //
                    //path = "https://axos.cc/bucket/video/"+video_hash;
                    path = BUCKET_API_SERVER + "/bucket/video/"+video_hash;
                    break;
                case "v":
                    //path = "https://axos.cc/bucket/video/"+video_hash;
                    path = BUCKET_API_SERVER + "/bucket/video/"+video_hash;
                    break
                default:
                    //https://vimeo.com/672104119
                    bits = video_hash.split("/");
                    var video_id = "v:"+bits[bits.length - 1];
                    //path = "https://axos.cc/bucket/video/"+video_id;
                    path = BUCKET_API_SERVER + "/bucket/video/"+video_id;
                    break
            }

            console.log("gif.114:   READ PATH=",path, " video_hash=",video_hash);
            processGifVideo(path, drill_key);
            return;




                    /*
                    // get the player HTML and parse for the content url
                    //
                    path = "https://player.vimeo.com/video/"+video_id;
                    var out = await getVimeoURL(path);

                    // feed the content url stream to the gif maker
                    //
                    var url = find_mp4_url(out);
                    if(url) {
                        console.log('vimeodl.2433:  Downloading "' + url + '"...');
                        processGifVideo(url, drill_key);
                    }
                    return;
            }
            */
                
        }

    return (
        <React.Fragment>
            <div id="gif_root" className={classes.gif_root} >
                <input type="file" id="file" name="file" encType="multipart/form-data" />
                <img id="output" src="" className={classes.img_container} />

            </div>
        </React.Fragment>
    )
}

export default Gif;